import { Button, Group, Modal, NumberInput } from '@mantine/core';
import { useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';

export const MAX_CODES_PER_REQUEST = 10000;

const AddCodesModal = ({ coupon, onClose, onAdded }) => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();
  const [rawCount, setRawCount] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState();

  const count = typeof rawCount === 'string' && rawCount.trim() !== '' ? Number(rawCount) : rawCount;
  const isCountValid = Number.isInteger(count) && count >= 1 && count <= MAX_CODES_PER_REQUEST;

  const close = () => {
    setRawCount('');
    setError(undefined);
    onClose();
  };

  const submit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(undefined);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/coupons/${coupon.id}/codes`, {
      method: 'POST',
      body: JSON.stringify({ count }),
    })
      .then(() => {
        close();
        onAdded?.();
      })
      .catch(setError)
      .finally(() => setSubmitting(false));
  };

  return (
    <Modal opened={Boolean(coupon)} onClose={close} title="Add Codes">
      {coupon && (
        <form onSubmit={submit}>
          <NumberInput
            label="Number of codes"
            description={`These will be added to ${coupon.name}`}
            min={1}
            max={MAX_CODES_PER_REQUEST}
            allowDecimal={false}
            allowNegative={false}
            value={rawCount}
            onChange={setRawCount}
          />
          <Group justify="flex-end" mt="md">
            <Button variant="default" onClick={close} disabled={submitting}>
              Cancel
            </Button>
            <Button type="submit" disabled={!isCountValid} loading={submitting}>
              Add Codes
            </Button>
          </Group>
          {error && <ErrorMessage message={error.message} />}
        </form>
      )}
    </Modal>
  );
};

export default AddCodesModal;
